import { AutoRelaySwitchScheduleEventDeviceConfig } from '@thingslog/repositories';
import { EventConfigFactory } from './EventConfigFactory';

export class AutoRelaySwitchFactory implements EventConfigFactory {
  public create(deviceNumbers: string[]): AutoRelaySwitchScheduleEventDeviceConfig {
    return {
      '@type': 'AUTO_RELAY_SWITCH',
      deviceCommand: 'AUTO_RELAY_SWITCH',
      deviceNumbers,
      requiredState: 'OFF',
    };
  }
}
